import { cls } from "@wss/cls";
import React, { FC, ComponentProps } from "react";

const Section: FC<ComponentProps<"div">> = ({
  className,
  children,
  ...rest
}) => {
  return (
    <div className={cls("pt-4", className)} {...rest}>
      {children}
    </div>
  );
};

export default Section;
